import { SVGFC } from '@repo/toolkit/types'

const CheckListTwoIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_14763_109371)">
        <path
          d="M16.75 15.9434H14C13.7411 15.9434 13.5312 16.1532 13.5312 16.4121C13.5312 16.671 13.7411 16.8809 14 16.8809H16.75C17.0089 16.8809 17.2188 16.671 17.2188 16.4121C17.2188 16.1532 17.0089 15.9434 16.75 15.9434Z"
          fill={color}
        />
        <path
          d="M16.75 12.2793H14C13.7411 12.2793 13.5312 12.4892 13.5312 12.748C13.5312 13.0069 13.7411 13.2168 14 13.2168H16.75C17.0089 13.2168 17.2188 13.0069 17.2188 12.748C17.2188 12.4892 17.0089 12.2793 16.75 12.2793Z"
          fill={color}
        />
        <path
          d="M11.3006 11.6402C11.1018 11.4743 10.8062 11.5008 10.6403 11.6995L9.84877 12.6474L9.66918 12.289C9.55321 12.0575 9.27158 11.9639 9.04011 12.0799C8.80864 12.1959 8.71505 12.4775 8.83102 12.709L9.33102 13.7069C9.4018 13.8482 9.53902 13.9443 9.69602 13.9625C9.71414 13.9646 9.73218 13.9657 9.75018 13.9657C9.88814 13.9657 10.0203 13.9047 10.1099 13.7974L11.3599 12.3005C11.5258 12.1018 11.4992 11.8061 11.3006 11.6402Z"
          fill={color}
        />
        <path
          d="M11.5193 15.109C11.3206 14.943 11.025 14.9696 10.8591 15.1683L10.0675 16.1162L9.88793 15.7577C9.77196 15.5263 9.49033 15.4326 9.25886 15.5486C9.02739 15.6646 8.9338 15.9463 9.04977 16.1777L9.54977 17.1756C9.62055 17.3169 9.75777 17.413 9.91477 17.4313C9.93289 17.4334 9.95093 17.4344 9.96893 17.4344C10.1069 17.4344 10.2391 17.3735 10.3287 17.2661L11.5787 15.7693C11.7446 15.5705 11.718 15.2749 11.5193 15.109Z"
          fill={color}
        />
        <path
          d="M17.4688 6.60775V6.40625C17.4688 5.63084 16.8379 5 16.0625 5H9.9375C9.16209 5 8.53125 5.63084 8.53125 6.40625V6.60775C7.52116 6.87225 6.78125 7.79516 6.78125 8.875V18.6562C6.78125 19.9486 7.83266 21 9.125 21H16.875C18.1673 21 19.2188 19.9486 19.2188 18.6562V8.875C19.2188 7.79516 18.4788 6.87225 17.4688 6.60775ZM9.46875 6.40625C9.46875 6.14778 9.67903 5.9375 9.9375 5.9375H16.0625C16.321 5.9375 16.5312 6.14778 16.5312 6.40625V7.5625C16.5312 7.82097 16.321 8.03125 16.0625 8.03125H9.9375C9.67903 8.03125 9.46875 7.82097 9.46875 7.5625V6.40625ZM18.2812 18.6562C18.2812 19.4317 17.6504 20.0625 16.875 20.0625H9.125C8.34959 20.0625 7.71875 19.4317 7.71875 18.6562V8.875C7.71875 8.31466 8.05072 7.82497 8.53222 7.60016C8.55228 8.35819 9.17472 8.96875 9.9375 8.96875H16.0625C16.8253 8.96875 17.4477 8.35819 17.4678 7.60016C17.9493 7.82497 18.2812 8.31466 18.2812 8.875V18.6562Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_14763_109371">
          <rect width="16" height="16" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CheckListTwoIcon
